<template>
    <div v-loading="loading" class="outlineApp">
    <div class="mian">
      <div class="contents">
        <h2>{{ examDetailed.title }}</h2>
        <div v-if="examLate" class="late_tips">考试中，您已迟到</div>
        <div class="describe">
          <div>考试类型<span>{{ examDetailed.app_name }}阶段测试</span></div>
          <div>考试题量<span>{{ examDetailed.question_count }}道</span></div>
          <div>卷面分值<span>{{ examDetailed.score }}分</span></div>
          <div>考试时间<span>{{ examDetailed.answer_time?examDetailed.answer_time+'分钟':'不限时' }}</span></div>
          <div>起止时间<span>{{ examDetailed |startTimeFilter }}~{{ examDetailed|endTimeFilter }}</span></div>
          <div>答题规则<span>{{ modeTitle }}<span v-if="modeTitle!='正常模式'" class="rule" @click="showRule">答题规则 >></span></span></div>
        </div>
        <div v-if="examDetailed.description" class="tips">
          <h3><span />考试说明</h3>
          <div class="tips-description" v-html="examDetailed.description" />
        </div>
        <div class="tips">
          <h3><span />注意事项</h3>
          <div class="tips-item">
            1、进入考试后，请不要中途离开，中途离开视为直接交卷，扣除考试次数；
          </div>
          <div class="tips-item">
            2、请保持网络较好的环境参与考试；
          </div>
          <div class="tips-item">
            3、同时，进入考试后，请不要切换网页、退出浏览器等，会触发防作弊机制，多次触发也会按交卷处理，扣除考试次数；
          </div>
        </div>
      </div>

      <div class="strart">
        <el-button
          v-if="examLate&&examDetailed.time===0"
          class="retest"
          disabled
        >考试中，您已迟到</el-button>
        <el-button
          v-if="examDetailed.time===0&&examDetailed.status===1&&!examLate"
          type="primary"
          @click="goStrartExam(1)"
        >开始考试({{ examDetailed.answer_number?'剩余：'+(examDetailed.answer_number)+'次':'不限次数' }})</el-button>
        <el-button
          v-if="examDetailed.time!==0&&examDetailed.answer_number - examDetailed.time !==0&&examDetailed.status===1"
          type="primary"
          @click="goStrartExam(2)"
        >重新考试({{ examDetailed.answer_number?'剩余：'+ (examDetailed.answer_number - examDetailed.time)+'次':'不限次数' }})</el-button>

        <el-button
          v-if="(examDetailed.review===1&&examDetailed.time===1&&examDetailed.answer_number - examDetailed.time ===0)
            ||examDetailed.status===2||(examDetailed.review===1&&(examDetailed.answer_number - examDetailed.time ===0||examDetailed.answer_number===0))"
          class="review"
          @click="goStrartExam(3)"
        >回顾考试</el-button>
        <el-button
          v-else-if="examDetailed.time!==0&&examDetailed.answer_number - examDetailed.time ===0&&examDetailed.status===1"
          class="retest"
          disabled
        >重新考试(剩余0次)</el-button>
        <el-button
          v-if="examDetailed.status===0"
          class="retest"
          disabled
        >等待考试开始</el-button>
      </div>
    </div>
    <img class="Illustration" src="@/assets/img/examoutline.png">
    <examTips
      :tip-parmas="tipParmas"
      @confirm="tipsConfirm"
      @cancel="tipsClose"
    />
    <!-- 成绩统计 -->
    <examStatistics :show-score="showScore" :show-rank="showRank" :statistics-type="statisticsType" :statistics-visible="statisticsVisible" :test-info="testInfo" @update:statisticsVisible="statisticsChange" />
    <!-- 考试模式提示 -->
    <examTypeTips :tip-parmas="tipTypeParmas" @know="know" />
  </div>
</template>
<script>
import { getExamDetailed, joinAndStartExam, getQuestion, severTime, updateFirstExam,saveCheatBatch } from '@/http/index'
import examTips from '../examList/child/tips.vue'
import { handleAnswer, handleScore, fullScreen } from '@/utils/exam'
import { dateMinutes, nowTime, processDate, dateToString, dateToString2, ExamFileDecryptor,getExamTimestamp } from '@/utils/index'
import examStatistics from '../examList/child/statistics.vue'
import examTypeTips from '../examList/child/typeTips.vue'
import {getCurrentLocation,getDistance,checkGeolocationPermission} from '@/utils/location'

export default {
  components: {
    examTips, examStatistics, examTypeTips
  },
  filters: {
    startTimeFilter(val) {
      return processDate(val.start_time, val.ent_time)
    },
    endTimeFilter(val) {
      return processDate(val.ent_time, val.start_time, 1)
    }
  },
  data() {
    return {
      loading: true,
      showRank: false,
      btnStatus: null,
      examDetailed: {},
      tipParmas: {
        tipsVisible: false,
        tipsContent: '',
        disabled: false
      },
      btnConfirmType: 'joinTest',
      statisticsType: '0',
      statisticsVisible: false,
      testInfo: {},
      testPaper: [],
      addressInfo: {
        lat: 0,
        lng: 0,
        address: '未知',
      },
      showScore: false,
      isSafari: false,
      examLate: false,
      modeTitle: '',
      tipTypeParmas: {
        tipsVisible: false,
        title: '',
        tipsContent: ''
      },
      answerDetail: {},
    }
  },

  async created() {
    this.isSafari = localStorage.getItem('isSafari')
    this.getExamInfo();
    // this.getIPAddress();
  },
  methods: {
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    generateKeys(array) {
      if (array && array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          const new_key = String.fromCharCode(65 + i);
          array[i].new_key = new_key;
        }
        return array;
      }
      return []
    },
    buildExamPaperForEntry() {
      const optionShuffleCache = {}
      let examlist = this.testPaper.map(item => {
        const nextItem = JSON.parse(JSON.stringify(item))
        if (nextItem.type === 22) {
          nextItem.option = JSON.stringify([{
            key: 'A',
            title: '正确'
          }, {
            key: 'B',
            title: '错误'
          }])
          nextItem.answer = JSON.parse(nextItem.option).filter(obj => obj.title == nextItem.answer)[0].key
        }
        let optionList = typeof nextItem.option === 'string' ? JSON.parse(nextItem.option) : nextItem.option
        if (this.examDetailed.option_sort == 2 && !this.examDetailed.reset_answer.is_reset) {
          optionList = JSON.parse(JSON.stringify(optionList || []))
          if (nextItem.type == 16 && nextItem.public_number) {
            const groupKey = `btype_${nextItem.public_number}`
            if (!optionShuffleCache[groupKey]) {
              optionShuffleCache[groupKey] = this.shuffleArray(optionList)
            }
            optionList = optionShuffleCache[groupKey]
          } else {
            optionList = this.shuffleArray(optionList)
          }
          nextItem.option = this.generateKeys(optionList)
        } else {
          nextItem.option = this.generateKeys(optionList)
        }
        return nextItem
      })

      if (this.examDetailed.question_sort == 2 && !this.examDetailed.reset_answer.is_reset) {
        const examGroup = examlist.reduce((r, c) => {
          if (!r[c.type]) {
            r[c.type] = []
          }
          r[c.type].push(c)
          return r
        }, {})
        const topicsSeq = [1, 11, 12, 15, 16, 17, 22, 2, 18, 19, 8]
        const groupedSorted = topicsSeq.map(order => examGroup[order]).filter(v => v && v.length !== 0)
        const shuffledArray = groupedSorted.map(item => {
          if (item[0].type == 8 || item[0].type == 15 || item[0].type == 16) {
            const groupedData = item.reduce((acc, obj) => {
              if (obj.public_number) {
                let group = acc.find(group => group.name === obj.public_number)
                if (!group) {
                  group = { name: obj.public_number, list: [] }
                  acc.push(group)
                }
                group.list.push(obj)
              } else {
                acc.push({ name: obj.id, list: [obj] })
              }
              return acc
            }, [])
            const groupedData2 = this.shuffleArray(JSON.parse(JSON.stringify(groupedData)))
            return groupedData2.reduce((acc, item) => acc.concat(item.list), [])
          }
          return this.shuffleArray([...item])
        })
        examlist = shuffledArray.reduce((r, c) => {
          if (typeof c !== 'undefined') {
            r = r.concat(...c)
          }
          return r
        }, [])
      }

      return examlist
    },
    buildInitialExamState(examPaper) {
      return examPaper.map(item => {
        const nextItem = JSON.parse(JSON.stringify(item))
        nextItem.remarks = false
        if (this.examDetailed.reset_answer.is_reset && this.examDetailed.reset_answer.answer.length > 0) {
          const savedAnswer = this.examDetailed.reset_answer.answer.find(obj => obj.question_id == nextItem.id)
          if (savedAnswer) {
            nextItem.remarks = !!savedAnswer.remarks
            if (nextItem.type === 2 || nextItem.type === 8 || nextItem.type === 18 || nextItem.type === 19) {
              nextItem.value = savedAnswer.answer ? savedAnswer.answer.replace(/,/g, '').replace(/，/g, '').split('') : []
            } else {
              nextItem.value = savedAnswer.answer || ''
            }
            return nextItem
          }
        }
        if (nextItem.type === 2 || nextItem.type === 8 || nextItem.type === 18 || nextItem.type === 19) {
          nextItem.value = []
        } else {
          nextItem.value = ''
        }
        return nextItem
      })
    },
    know() {
      this.tipTypeParmas.tipsVisible = false;
    },
    showRule() {
      this.tipTypeParmas = {
        showTime: false,
        tipsVisible: true,
        title: `${this.examDetailed.answer_mode == 2 ? '逐题模式' : '逐题型模式'}（${this.examDetailed.answer_rule == 1 ? '禁止回看' : '禁止回做'}）已开启`,
        tipsContent: this.examDetailed.answer_mode == 2 && this.examDetailed.answer_rule == 1 ? '<p>1.此模式下必须按照题号顺序答题</p><p>2.需做完当前题目才能切换下一题作答</p><p>3.已做过的题目禁止再次点击查看</p>'
          : this.examDetailed.answer_mode == 2 && this.examDetailed.answer_rule == 2 ? '<p>1.此模式下必须按照题号顺序答题</p><p>2.需做完当前题目才能切换下一题作答</p><p>3.已做过的题目仅支持查看，禁止再次答题</p>'
            : this.examDetailed.answer_mode == 3 && this.examDetailed.answer_rule == 1 ? '<p>1.此模式下必须按照题型顺序答题</p><p>2.需做完当前题型内所有题目才能切换下一题型作答</p><p>3.已做完的题型禁止再次点击查看</p><p>4.当前正在做的题型内所有题目可随意查看及作答(部分情况下题组题型除外，请留意系统提示)</p>'
              : '<p>1.此模式下必须按照题型顺序答题</p><p>2.需做完当前题型内所有题目才能切换下一题型作答</p><p>3.已做完的题型仅支持查看，禁止再次答题</p><p>4.当前正在做的题型内所有题目可随意查看及作答(部分情况下题组题型除外，请留意系统提示)</p>'
      }
    },
    // getIPAddress() {
    //   const url = "https://restapi.amap.com/v3/ip?parameters"
    //   const params = {
    //     key: "5a00269f074572c2d96d2779da41ae44"
    //   }
    //   axios({
    //     method: "get",
    //     url,
    //     params
    //   }).then(res => {
    //     this.address = res.data.city;
    //   })
    // },
    statisticsChange() {
      this.statisticsVisible = false;
      this.$router.go(-1);
    },
    async getExamInfo() {
      try {
        const queryData = {
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id'),
          exam_id: this.$route.query.id
        }
        const { data } = await getExamDetailed(queryData)
        this.answerDetail = data.answer
        localStorage.setItem('examChangeTime',data.exam_change_time)
        localStorage.setItem('examDisconnectInternet',data.exam_disconnect_internet)
        this.examDetailed = data;
        this.modeTitle = this.examDetailed.answer_mode == 1 ? '正常模式' : `${this.examDetailed.answer_mode == 2 ? '逐题模式' : '逐题型模式'}（${this.examDetailed.answer_rule == 1 ? '禁止回看' : '禁止回做'}）`
        if (this.examDetailed.late_minute && !this.examDetailed.reset_answer.is_reset) {
          const lefttime  = new Date().getTime() - getExamTimestamp(this.examDetailed.start_time)
          const mm = Math.floor((lefttime / (1000 * 60)) % 60)
          const hh = Math.floor((lefttime / (1000 * 60 * 60)) % 24)
          const minutes = hh ? hh * 60 + mm : mm
          if ((minutes >=  this.examDetailed.late_minute)) {
            this.examLate = true;
          }
        }
        this.getExamPaper();
      } catch (error) {
        this.loading = false;
      }
      if(!this.$route.query.isReview && this.examDetailed.location_permission_web == 1){
        await getCurrentLocation()
      }
    },
    async getExamPaper() {
      const paramsObj = {
        exam_id: this.$route.query.id,
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id')
      }
      const { data } = await getQuestion(paramsObj)
      const url = 'https://ksxt-image-1.yikaobang.com.cn/exam/' + data.url.split('/exam/')[1]
      try {
        const datas = await ExamFileDecryptor.fetchAndDecrypt(url)
        this.testPaper = datas;
        if (this.examDetailed.is_in_exam) {
          if (localStorage.getItem('testInfo') && this.examDetailed.id == localStorage.getItem('examId')) {
            this.btnConfirmType = 'submit'
            this.assemblyData(1)
            return
          }
          this.btnConfirmType = 'submit'
          this.assemblyData(2);
          return
        }
        this.loading = false;
      } catch (error) {
        console.error(error)
        this.loading = false;
      }
    },
    // 根据是否开启切屏作弊生成开始考试提示语
    getStartExamTipContent() {
      const startExamTip = '<div>开始考试后不可返回，直到交卷或考试结束后才可退出，如关闭应用则直接按交卷处理，确认开始考试吗?</div>'
      if (Number(this.examDetailed.switch_cheat || 0) !== 1) {
        return startExamTip
      }
      return `<div>
        <div>考试期间严禁各种作弊行为(切屏、使用其他各类软件搜索答案等)，系统将对所有违规行为进行自动监测并记录留档，未来可能会产生不可预知的负面影响，请严格遵守考场秩序，诚信应考。</div>
        ${startExamTip}
      </div>`
    },
    async goStrartExam(status) {
      //
      this.btnStatus = status;
      if (this.testPaper.length === 0) {
        this.btnConfirmType = 'appTips'
        this.tipParmas = {
          tipsContent: `<div>当前网络环境不好，请在网络良好的环境开始考试或稍后刷新后重试</div`,
          tipsVisible: true,
          confirmText: '确定',
          showClose: true,
          disabled: false
        }
        return
      }
      if (this.btnStatus === 1 || this.btnStatus === 2) {
        // if (this.examDetailed.late_minute && !this.examDetailed.reset_answer.is_reset) { // 设置了考试迟到时间
        //   const lefttime  = this.isSafari ? new Date().getTime() - new Date(this.examDetailed.start_time.replace(/-/g, '/')).getTime() : new Date().getTime() - new Date(this.examDetailed.start_time).getTime()
        //   const mm = Math.floor((lefttime / (1000 * 60)) % 60)		// 分
        //   const hh = Math.floor((lefttime / (1000 * 60 * 60)) % 24)		// 小时
        //   const minutes = hh ? hh * 60 + mm : mm
        //   if ((minutes >=  this.examDetailed.late_minute)) {
        //     return this.$message.error('考试迟到，无法进入考试')
        //   }
        // }

        if (this.examDetailed.is_in_exam) {
          if (this.examDetailed.exam_client !== 'web') {
            this.tipParmas = {
              tipsContent: `<div>您已在APP端参加考试还未交卷，无法通过PC端同时参考</div>`,
              tipsVisible: true,
              confirmText: '确定',
              showClose: true,
              disabled: false
            }
            this.btnConfirmType = 'appTips'
            return
          }
        }

        if (this.examDetailed.need_alert_first_exam) {
          let is_first_exam = ''
          this.$confirm(`请选择您是否首考，选择后即可进入考试`,
            "提示", {
              showClose: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              confirmButtonText: "是",
              cancelButtonText: "不是",
              type: "info",
              callback: (action) => {
                if (action === 'confirm') {
                  is_first_exam = 1
                } else {
                  is_first_exam = 2
                }
                this.examDetailed.need_alert_first_exam = 0
                updateFirstExam({
                  token: localStorage.getItem("token"),
                  secret: localStorage.getItem("secret"),
                  hospital_id: localStorage.getItem("hospital_id"),
                  is_first_exam
                })
                const tipTest = this.getStartExamTipContent()
                this.btnConfirmType = 'joinTest'
                this.tipParmas = {
                  tipsContent: (this.btnStatus === 1 || this.examDetailed.reset_answer.is_reset) ? `${tipTest}` : `<div>重新考试的成绩将不进行排名分析，是否继续</div>`,
                  tipsVisible: true,
                  confirmText: '确定',
                  showClose: false,
                  disabled: false
                }
              }
            })
        } else {
          const tipTest = this.getStartExamTipContent()
          this.btnConfirmType = 'joinTest'
          this.tipParmas = {
            tipsContent: (this.btnStatus === 1 || this.examDetailed.reset_answer.is_reset) ? `${tipTest}` : `<div>重新考试的成绩将不进行排名分析，是否继续</div>`,
            tipsVisible: true,
            confirmText: '确定',
            showClose: false,
            disabled: false
          }
        }
      } else {
        if (this.examDetailed.result == 3) {
          return this.$message.warning('本场考试不在系统中公布成绩，有问题请联系管理员')
        }
        if(this.examDetailed.absent_review == 2 && this.examDetailed.time <= 0){
          return this.$message.warning('本场考试缺考学员无法回顾作答详情，有问题请联系管理员')
        }
        if (this.examDetailed.option_sort == 2 && this.examDetailed.review_option.includes("answer_detail")) {
          this.btnConfirmType = 'sortTips'
          this.tipParmas = {
            tipsContent: `<div>该考试开启了选项乱序，考试中选项是乱序的，而回顾作答记录时是按顺序回顾的，所以可能和考试中顺序不一致！</div`,
            tipsVisible: true,
            confirmText: '我已知晓',
            showClose: false,
            disabled: false
          }
          return
        }
        // 回顾
        // this.$router.push({ name: 'Examining', query: {
        //   id: this.examDetailed.id,
        //   type: 'review'
        // }})
        this.$router.push({ name: 'review', query: {
          id: this.examDetailed.id,
          type: 'review'
        }})
        this.$store.commit('editExamDetailed', this.examDetailed);
        localStorage.setItem('testPaper', JSON.stringify(this.testPaper))
      }
    },
    async assemblyData(type) {
      var parmas = {}
      if(this.examDetailed.location_permission_web == 1){
        this.addressInfo = await getCurrentLocation()
      }
      const res = await severTime();
      const  date_end = res.data.sever_time;
      if (type === 1) {
        const exam_time = localStorage.getItem('stayTime') ? localStorage.getItem('stayTime') : 0
        console.log(exam_time, 'exam_time-------------')
        // const exam_time =  dateMinutes(localStorage.getItem('examTimeStart'))
        const answer = handleAnswer();
        const unsentArr = handleAnswer(JSON.parse(localStorage.getItem('unsentAnswers') || '[]'))
        const total = handleScore();
        parmas = {
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id'),
          // app_id: this.examDetailed.app_id,
          exam_id: this.examDetailed.id,
          answer: JSON.stringify(unsentArr),
          answer_num: answer.filter(item => item.answer).length,
          exam_date_start: this.examDetailed.reset_answer.is_reset ? this.examDetailed.reset_answer.date_start : localStorage.getItem('examTimeStart'),
          // date_end: date_end,
          right: answer.filter(item => item.is_right === 1).length,
          score: total < 0 ? 0 : Number.isInteger(total) ? total : total.toFixed(1),
          exam_time: this.examDetailed.reset_answer.is_reset ? Number(exam_time) + Number(this.examDetailed.reset_answer.exam_time) : exam_time,
          submit_type: 7,
          reset: this.examDetailed.reset_answer.is_reset ? 1 : null,
          address: this.addressInfo.address,
          lat:this.addressInfo.lat,
          lng:this.addressInfo.lng,
          complete: 1,
          last_answer: localStorage.getItem('nowTopic') ? JSON.parse(localStorage.getItem('nowTopic')).id : '',
          id: this.answerDetail.id || localStorage.getItem('examAnswerId'),
          no_complete: unsentArr.length > 0 ? 0 : 1,
        }
        this.submitTest(parmas)
      } else {
        // const answer = []
        // const datas = this.testPaper;
        // if (this.examDetailed.reset_answer && this.examDetailed.reset_answer.is_reset) {
        //   datas.map(item => {
        //     answer.push({
        //       answer: this.examDetailed.reset_answer.answer.find(obj => obj.question_id == item.id) ? this.examDetailed.reset_answer.answer.find(obj => obj.question_id == item.id).answer : '',
        //       question_id: item.id,
        //       is_right: this.examDetailed.reset_answer.answer.find(obj => obj.question_id == item.id) ? this.examDetailed.reset_answer.answer.find(obj => obj.question_id == item.id).is_right : 0
        //     })
        //     // this.examDetailed.reset_answer.answer.map(obj => {
        //     // if (obj.question_id == item.id) {
        //     //   answer.push({
        //     //     answer: obj.answer,
        //     //     question_id: item.id,
        //     //     is_right: obj.is_right
        //     //   })
        //     // } else {
        //     //   answer.push({
        //     //     answer: '',
        //     //     question_id: item.id,
        //     //     is_right: 0
        //     //   })
        //     // }
        //     // })
        //   })
        // } else {
        //   datas.map(item => {
        //     answer.push({
        //       answer: '',
        //       question_id: item.id,
        //       is_right: 0
        //     })
        //   })
        // }
        const exam_time2 = localStorage.getItem('stayTime') ? localStorage.getItem('stayTime') : 0
        // const exam_time2 = localStorage.getItem('examTimeStart') ? dateMinutes(localStorage.getItem('examTimeStart')) : 0;
        parmas = {
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id'),
          // app_id: this.examDetailed.app_id,
          exam_id: this.examDetailed.id,
          answer: JSON.stringify([]),
          answer_num: 0,
          exam_date_start: localStorage.getItem('examTimeStart') ? localStorage.getItem('examTimeStart') : date_end,
          // date_end: date_end,
          right: 0,
          score: 0,
          exam_time: this.examDetailed.reset_answer.is_reset ? Number(exam_time2) + Number(this.examDetailed.reset_answer.exam_time) : exam_time2,
          submit_type: 7,
          reset: this.examDetailed.reset_answer.is_reset ? 1 : null,
          address: this.addressInfo.address,
          lat:this.addressInfo.lat,
          lng:this.addressInfo.lng,
          complete: 1,
          no_complete: 1,
          id: this.answerDetail.id || localStorage.getItem('examAnswerId'),
          last_answer: ''
        }
        this.submitTest(parmas)
      }
    },
    // 修改时间触发作弊
    async isModifyTime(){
      const localTime = new Date().getTime()
      const severTimeRes = await severTime()
      const serverTime = new Date(severTimeRes.data.sever_time).getTime()
      const timeDiff = Math.abs(localTime - serverTime) / 1000  // 转换为秒
      if (timeDiff > Number(this.examDetailed.exam_change_time)) {
        const cheat_data_json = JSON.stringify([{
            exam_id: this.examDetailed.id,
            date_start: this.answerDetail.date_start || localStorage.getItem('examTimeStart'),
            time: time || 1,
            type: 9,
            is_cheat: 2,
            date_time: nowTime(localTime),
            behavior_type: 'end'
          }])
        const res = await saveCheatBatch({
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id'),
          cheat_data:cheat_data_json
        })
      }
    },
    submitTest(parmas) {
      this.$store.dispatch('onceSubmit', parmas).then(res => {
        if (res.code === 200) {
          this.tipParmas.tipsVisible = false;
          this.isModifyTime()
          this.$message.success("提交成功");
          localStorage.removeItem('examId')
          localStorage.removeItem('testInfo')
          localStorage.removeItem('unsentAnswers')
          localStorage.removeItem('examTimeStart')
          localStorage.removeItem('examing')
          localStorage.removeItem('nowTopic')
          this.testInfo = {
            avatar: this.$store.state.userInfo.avatar,
            realname: this.$store.state.userInfo.realname,
            score: parmas.score < 0 ? 0 : parmas.score,
            time: parmas.exam_time,
            pass: parmas.score >= this.examDetailed.pass_score ? '及格' : '不及格',
            exam_id: this.examDetailed.id,
            exam_name: this.examDetailed.title,
            rate: Math.trunc((parmas.score / this.examDetailed.score) * 100),
            review_option: this.examDetailed.review_option ? this.examDetailed.review_option.split(',') : ''
          }
          this.showScore = this.examDetailed.result != 3
          this.tipParmas = {
            tipsContent: `<div>检测到您在未交卷的情况下关闭浏览器窗口，为防止作弊已自动提交考试答案！</div>`,
            tipsVisible: true,
            confirmText: '确认',
            showClose: true,
            disabled: false
          }
        }
      })
    },
    tipsClose(val) {
      this.tipParmas.tipsVisible = false;
      if (this.btnConfirmType === 'submit') {
        this.statisticsVisible = true;
      }
    },
    // 距离定位最近的考点id
    getPointDistance(){
      let nearest = null;
      let minDistance = Infinity;
      this.examDetailed.exam_points.forEach(item => {
        const distance = getDistance(
          this.addressInfo.lat,
          this.addressInfo.lng,
          Number(item.lat),
          Number(item.lng)
        );

        if (distance < minDistance) {
          minDistance = distance;
          nearest = { ...item, distance };
        }
      })
      return nearest?.id || this.examDetailed.exam_points[0]?.id || ''
    },
    async tipsConfirm() {
      if (this.btnConfirmType === 'appTips') {
        this.tipParmas.tipsVisible = false;
        return
      }
      if (this.btnConfirmType === 'submit') {
        this.statisticsVisible = true;
        return
      }
      if (this.btnConfirmType === 'sortTips') {
        this.tipParmas.tipsVisible = false;
        this.$router.push({ name: 'Examining', query: {
          id: this.examDetailed.id,
          type: 'review'
        }})
        this.$store.commit('editExamDetailed', this.examDetailed);
        localStorage.setItem('testPaper', JSON.stringify(this.testPaper))
        return
      }
      this.tipParmas.disabled = true

      if(this.examDetailed.location_permission_web == 1){
        const permission = await checkGeolocationPermission()
          if (permission === 'denied' && !this.examDetailed.verification_free_exam_point) {
            this.$confirm(
              '定位权限被拒绝，请点击浏览器地址栏右侧定位图标手动开启定位权限后刷新页面重试',
              '提示',
              {
                confirmButtonText: '确定',
                type: 'warning',
                showCancelButton: false,
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false
              }
            ).then(() => {
              // 用户点击确定
              this.tipParmas.disabled = false
              this.tipParmas.tipsVisible = false;
            }).catch(() => {
              // 用户点击取消
            })
            return
        }
        this.addressInfo = await getCurrentLocation()
      }

      const finalExamPaper = this.examDetailed.reset_answer.is_reset ? this.testPaper : this.buildExamPaperForEntry()
      let initialExamState = null
      if(!this.examDetailed.reset_answer.is_reset){
        initialExamState = this.buildInitialExamState(finalExamPaper)
      }
      joinAndStartExam({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        exam_id: this.examDetailed.id,
        address: this.addressInfo.address,
        lat:this.addressInfo.lat,
        lng:this.addressInfo.lng,
        reset: this.examDetailed.reset_answer.is_reset ? 1 : 0,
        point_id: this.getPointDistance(),
        app_id: this.examDetailed.app_id,
        answer: initialExamState ? JSON.stringify(handleAnswer(initialExamState)) : ''
      }).then(res => {
        if (res.code === 200) {
          fullScreen()
          this.examDetailed = res.data
          this.answerDetail = res.data.answer || {}
          this.$store.commit('editExamDetailed', res.data);
          localStorage.setItem('testInfo', JSON.stringify(initialExamState))
          localStorage.setItem('testPaper', JSON.stringify(finalExamPaper))
          localStorage.setItem('examSeverTime', res.data.sever_time)
          localStorage.setItem('examTimeStart', res.data.answer.date_start)
          localStorage.setItem('examAnswerId', res.data.answer.id)
          localStorage.setItem('examId', this.examDetailed.id)
          localStorage.setItem('userId', this.$store.state.userInfo.user_id)
          localStorage.setItem('examChangeTime', res.data.exam_change_time)
          localStorage.setItem('examDisconnectInternet', res.data.exam_disconnect_internet)
          this.$nextTick(() => {
            this.$router.push({ name: 'Examining', query: {
              id: this.examDetailed.id
            }})
          })
          this.tipParmas.disabled = false
        }
        this.tipParmas.disabled = false
      }).catch(err => {
        this.tipParmas.disabled = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .router_container{
    padding: 0 !important;
  }
}
.outlineApp {
    background-color: #F7F8FA;
    padding-bottom: 150px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-content: space-between;
}

.Illustration {
    width: 100%;
    height: 250px;
    position: fixed;
    left: 0;
    bottom: 0;
    // position: relative;
    // top: -50px;
    pointer-events: none;
    z-index: 1;
}

h2 {
    text-align: center;
    font-size: 18px;
    color: #303030;
    margin-bottom: 15px;
}

.mian {
    width: 70%;
    height: 100%;
    // overflow-y: scroll;
    background-color: #fff;
    padding: 24px 0 0 0;
    margin: 30px auto 0;
    z-index: 2;
}

.describe {
    /* display: flex; */
    /* justify-content: space-around; */
    font-size: 14px;
    font-family: Source Han Sans SC-Regular, Source Han Sans SC;
    font-weight: 400;
    color: #909090;
    padding-bottom: 12px;
    border-bottom: 1px solid #EEEEEE;
    margin-bottom: 24px;
    div{
      margin-bottom: 12px;
    }
    span{
      font-size: 14px;
      font-family: Source Han Sans SC-Regular, Source Han Sans SC;
      font-weight: 400;
      color: #303030;
      margin-left: 24px;
    }
}

.describeContent {
    padding-bottom: 40px;
    border-bottom: solid 2px #EEEEEE;
    text-align: left;
    line-height: 28px;
}

.red {
    color: #DD594A;
}

.tips {
    // padding-top: 40px;
}

h3 {
    font-size: 16px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #303030;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

h3 span {
    width: 3px;
    height: 14px;
    background-color: #DD594A;
    margin-right: 6px;
}
.tips-description{
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #909090;
  line-height: 28px;
  margin-bottom: 16px;
  white-space: pre-wrap;
}
.tips-item {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #909090;
  line-height: 28px;
}
.contents{
  height: calc(100% - 90px);
  overflow-y: scroll;
  padding: 0 24px;
}
.strart {
    text-align: center;
    z-index: 100 !important;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.el-button {
    width: 288px;
    // margin-top: 60px;
    background-color: #DD594A;
    border: solid 1px #DD594A;
}

.count-down{
    margin: 25px auto;
    display: flex;
    justify-content: center;
}
.review{
  background: rgba(221,89,74,0.08);
  border: 1px solid rgba(221,89,74,0.2);
  color: #DD594A;
}
.retest{
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  color: #BFBFBF;
}
.late_tips{
  text-align: center;
  margin: 10px 0;
}
.rule{
  margin-left: 4px !important;
  color: #DD594A !important;
  cursor: pointer;
}
</style>
